import { MODAL_LARGE_MAX_HEIGHT } from './overlayStyles';

/**
 * Default height cap for `AnimatedModalShell`'s dialog panel (standing order
 * 2026-09-23: every modal caps on web AND mobile — no modal ships uncapped).
 *
 * Same reasoning as the shell's `role="dialog"` default (see the comment above
 * `role="dialog"` in AnimatedModalShell.js): the default
 * belongs in the shell, not a per-caller key-list. 69 consumers already pass
 * a capped `dialogStyle` by hand today — this is the safety net for the 70th,
 * a future modal nobody remembers to cap.
 *
 * Uses `MODAL_LARGE_MAX_HEIGHT` (90dvh, no 720px desktop ceiling) rather than
 * the tighter compact family: a cap without an internal scroll region CLIPS
 * content instead of shrinking it, and the shell has no idea whether a given
 * caller's body scrolls. LARGE is the least-clipping cap that still clears
 * the notch / home indicator, so applying it blind can only ever help.
 *
 * A caller that already sets `maxHeight` (or a definite `height`, which makes
 * a cap moot) keeps its own value untouched — same object, same reference —
 * so this can only ever fill a gap, never fight an existing choice.
 */
export function withDefaultPanelCap(style) {
  if (style == null) return { maxHeight: MODAL_LARGE_MAX_HEIGHT };
  if (style.maxHeight == null && style.height == null) {
    return { ...style, maxHeight: MODAL_LARGE_MAX_HEIGHT };
  }
  return style;
}
